import React from "react"
import { Box } from "@mui/material"
import { ARIA_LABELS, LAYOUT } from "@/shared/components/image-gallery/constants"
import { ImageGalleryItem } from "@/shared/components/image-gallery/types"

interface MainImageViewportProps {
  item: ImageGalleryItem
  index: number
  total: number
}

const MainImageViewport: React.FC<MainImageViewportProps> = ({ item, index, total }) => {
  return (
    <Box sx={{ position: "relative", display: "inline-flex" }}>
      <Box
        component="img"
        src={item.url}
        alt={item.alt ?? ARIA_LABELS.image(index, total)}
        sx={{
          maxHeight: LAYOUT.imageMaxHeight,
          objectFit: "contain",
          userSelect: "none",
          pointerEvents: "none"
        }}
      />
    </Box>
  )
}

export default MainImageViewport
